<!-- =========================================================================================
  File Name: UserCreate.vue
  Description: User Create Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-edit">
    <div class="vx-row">
      <div v-if="user_data" class="vx-col w-full mb-base">

        <vs-alert color="warning" title="Internal User" v-if="isInternalUser" class="mb-4">
          <span>Some fields cannot be edited due to this user being an internal user on Azure AD</span>
        </vs-alert>

        <user-profile-form
          ref="profile"
          v-model="user_data"
          :loading="loading"
        />
        <user-details-form
          ref="userDetailsForm"
          v-model="user_data"
          :loading="loading"
        />
        <div class="vx-row">
          <div class="vx-col sm:w-1/2">
            <div class="mt-8 flex flex-wrap items-center justify-start">
              <vs-button
                  :disabled="loading"
                  class="my-4"
                  @click="cancel"
              >
                Cancel
              </vs-button>
            </div>
          </div>
          <div class="vx-col sm:w-1/2">
            <div class="mt-8 flex flex-wrap items-center justify-end">
              <vs-button
                  :disabled="loading"
                  class="my-4"
                  @click="save"
                  color="light"
              >
                Save
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import UserProfileForm from "../forms/UserProfileForm";
import UserValidation from "@/validation/User";
import UserDetailsForm from '../forms/UserDetailsForm';
UserValidation.init();

// Store Module
import FormValidateMixin from "../../../../components/mixins/FormValidateMixin";
import NotificationMixin from '../../../../components/mixins/NotificationMixin';
import SaveModelMixin from '../../../../components/mixins/SaveModelMixin';
import ViewModelMixin from '../../../../components/mixins/ViewModelMixin';

export default {
  components: {
    UserProfileForm,
    UserDetailsForm,
  },
  mixins: [
    ViewModelMixin,
    SaveModelMixin,
    NotificationMixin,
    FormValidateMixin,
  ],
  data () {
    return {
      internalLoading: false,
      user_not_found: false,
      user_data: null,
      forms: [
        'profile',
        'userDetailsForm',
      ]
    }
  },
  computed: {
    isInternalUser() {
      return this.user_data && this.user_data.IsInternalUser === true;
    }
  },
  methods: {
    async validateSave() {
      let valid = true;

      this.forms.forEach(form => {
        if (!this.$refs[form].validate()) {
          valid = false;
        }
      })

      return valid;
    },
    getParams() {
      const localData = this.setModelCopy({
        ...this.user_data,
      });

      const references = [
        'Company_FK',
        'connection',
        'LearningLevelType_FK',
        'AddressType_FK',
      ];

      const multiReferences = [
        {
          array: 'applications',
          key: 'SelectedRoleId',
        },
        {
          array: 'class_of_business',
          key: 'ClassOfBusiness_FK',
        },
        {
          array: 'email_addresses',
          key: 'EmailType_FK',
        },
        {
          array: 'phone_numbers',
          key: ['PhoneType_FK', 'CountryCode'],
        },
        {
          array: 'external_links',
          key: 'LinkType_FK',
        },
        {
          array: 'profile',
          key: ['FisgRoleType_FK', 'LearningLevelType_FK', 'ImpersonatedCompany'],
        },
      ];

      this.setMultiReferences(multiReferences, localData);
      this.setReferences(references, localData);
      localData.roleIds = [];

      if (localData.applications) {
        localData.roleIds = localData.applications.filter(application => application.SelectedRoleId > 0)
        .map(application => application.SelectedRoleId);
        delete localData.applications;
      }

      return localData;
    },
    async save() {
      if (!await this.validateSave()) {
        return false;
      }

      try {
        const params = this.getParams();

        await this.$api.users.update(this.$route.params.id, params)

        this.$vs.notify({
          color: 'success',
          title: 'Contact updated',
          text: 'The contact was successfully updated',
          position: 'top-right'
        })
      } catch (e) {
        this.addErrors(e);

        if (e.response.status !== 422) {
          this.$vs.notify({
            color: 'danger',
            title: 'Error occurred',
            text: e.response.data.message
                || 'Not able to update contact. Please try again.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-right'
          })
        }

        return;
      }

      await this.$router.back();
    },
    cancel() {
      this.$router.push({ name: 'contact.view', params: { id: this.user_data.id }}).catch(() => {});
    },
    async fetch(userId) {
      try {
        const { data } = await this.$api.users.get(userId);
        if (!data.data.email_addresses || data.data.email_addresses.length == 0) {
            data.data.email_addresses = [{
              EmailAddress: null,
              EmailType_FK: null,
              IsPrimaryEmail: null
            }];
        }

        if (!data.data.phone_numbers || data.data.phone_numbers.length == 0) {
          data.data.phone_numbers = [{
            PhoneType_FK: null,
            CountryCode: null,
            PhoneNumber: null,
            PhoneExtension: null,
          }];
        }

        this.user_data = data.data;
      } catch (e) {
        console.error(e)
      } finally {
        if (!this.user_data) {
          this.user_not_found = true
        }
      }
    }
  },
}

</script>
